<template>
  <div style="transform: none">
    <dp-side-options @setToPaper="setToPaper"></dp-side-options>

    <div class="container" data-scroll-container>
      <div class="title-box">
        <div class="title-text">
          <div class="title-name">π实验室</div>
          <div class="title-desc">
            利用丰富的工业互联网行业经验和安全知识，不断探索研究工业互联网安全领域的前沿技术，输出业界领先的实验成果，提升产品、解决方案、安全服务水平。
          </div>
        </div>
        <div class="title-pic"></div>
      </div>
      <div class="sub-title-text">
        <div v-for="item in titleList" :key="item.id" class="sub-title-text-item"
             :class="activeName === item.id? 'sub-title-text-pick': ''" @click="changeActive(item.id)">
          {{ item.name }}
        </div>
      </div>
      <div class="content-region">
        <div class="notice" v-if="activeName === 3 || activeName === 4 || activeName === 5">
          <div class="left-bar">
            <div class="left-icon" :style="getBackgroundStyle"></div>
            <div class="left-title">
              {{pickedTabName}}
            </div>
          </div>
          <div class="right-part">
            <template v-if="activeName === 3 || activeName === 4">
              <div class="right-part-title">
                <div class="title-icon"></div>
                <div class="title-text">{{pickedTabName}}</div>
              </div>
              <template v-if="activeName === 3">
                <div v-for="item in showList" :key="item.label" class="right-line">
                  <div class="right-line-text">{{ item.text }}</div>
                  <div class="right-line-time">
                    <div class="clock"></div>
                    <div>{{ item.time }}</div>
                  </div>
                </div>
              </template>
              <div class="feature-container" v-else>
                <div class="feature-item" v-for="(item,index) in showList" :key="index">
                  <div class="feature-kind">{{item.text.slice(0,7)}}</div>
                  <div class="feature-version">{{item.text.slice(7)}}</div>
                  <div class="feature-time">{{item.time}}</div>
                  <div class="feature-bg"></div>
                </div>
              </div>
<!--              <div class="page-container">-->
<!--                <div class="page-square" @click="decreasePage">《</div>-->
<!--                <div class="page-square" v-for="i in totalPage" :class="activePage === i? 'picked-page-square':''" @click="changeActivePage(i)">{{i}}</div>-->
<!--                <div class="page-square" @click="increasePage">》</div>-->
<!--              </div>-->
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="activePage"
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="totalItem">
              </el-pagination>
            </template>
            <div v-else>
              <div class="agreement-desc">双湃支持工控系统内工业机、控制设备、SCADA工业通信设备、网络安全设备5类工控系统组件的软件、信息采集，并支持工业网络中应用的通信协议的识别，具体包括如下103种协议：</div>
              <div class="agreement-pic"></div>
            </div>
          </div>
        </div>
        <div v-else-if="activeName === 1">
          <div class="lab-room-one">
            <div class="lab-room-one-content">
              <div class="lab-room-title">“π-Lab”工业互联网安全研究实验室</div>
              <div class="lab-room-desc">
                专注于工业互联网安全攻防技术研究和验证。从攻击者视角解决网络安全问题，并为安全服务团队赋能。持续跟踪国际、国内安全漏洞及趋势，专注工控产品漏洞研究。实验室搭建了MSICST多场景工业安全测试床，并发表多篇研究论文；实验室由行业丰富经验的安全专家组成，擅长攻防对抗技术，在威胁研究、后渗透阶段技术积累雄厚，并在内部推动安全研究成果体系化、服务化，让攻防能力更聚焦，服务效果更显著。
              </div>
              <div class="lab-room-one-ability">实验室特点：</div>
            </div>
            <div class="lab-room-one-list">
              <div class="lab-room-one-pic">
                <div class="lab-icon">π-Lab</div>
              </div>
              <div class="lab-room-one-capable">
                <div class="lab-capable-item" v-for="item in abilityList" :key="item.id">
                  <div class="lab-capable-iconbox">
                    <div class="lab-capable-icon" :style="getBgStyle(item)"></div>
                  </div>
                  <div>
                    <div class="lab-capable-title">{{item.name}}</div>
                    <div class="lab-capable-textbox">
                      <div class="lab-capable-textbox-item" v-for="(items,j) in item.subList" :key="j">
                        <div class="lab-capable-symbol"></div>
                        <div class="lab-capable-text">{{items}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lab-room-two">
            <div class="lab-room-two-bg"></div>
            <div class="lab-room-two-content">
              <div class="lab-room-title">工业互联网安全监测技术实验室</div>
              <div class="lab-room-desc desc-gap">
                双湃智安作为2020年工业互联网产业联盟实验室的牵头单位，与北京交通大学、中国化工信息中心联合成立。实验室以工业互联网安全态势感知技术、工业互联网安全防御技术、工业互联网安全测试床为主要研究方向，探索面向工业互联网企业的工业互联网安全技术，将科研成果、专利产业化，为工业互联网企业提供具有全生命周期的工业互联网安全解决方案。
              </div>
              <div class="lab-room-two-partner"></div>
            </div>
            <div class="lab-room-two-pic"></div>
          </div>
        </div>
        <div v-else class="report">
          <div class="report-item" v-for="item in pickedList" :key="item.id">
            <div class="pic" :style="{'backgroundImage': `url(${getPaperImg(item.id)})`}"></div>
            <div class="text">
              <div class="report-name">{{ item.name }}</div>
              <div class="report-desc">发布时间：{{ item.desc }}</div>
              <div class="report-download" @click="login" v-if="!loginState">白皮书下载</div>
              <a class="report-get report-download" :href="'/file/' + item.document" download v-else-if="item.document">白皮书下载</a>
              <div class="report-download" v-else>白皮书下载</div>
            </div>
          </div>
        </div>
      </div>
      <system-identify></system-identify>
      <dp-footer></dp-footer>
    </div>
  </div>
</template>
<script>
import scroller from "../components/mixins/scroller";
import  systemIdentify from "@/components/systemIdentify.vue";

export default {
  mixins: [scroller],
  components: {
    systemIdentify
  },
  data() {
    return {
      loginState: false,
      timeList: [],
      activeName: 1,
      activePage: 1,
      titleList: [
        {
          id:1,
          name:"实验室介绍"
        },
        {
          id: 2,
          name: "研究成果",
          children: [
            {
              id: 1,
              name: "2019中国工业互联网安全态势感知报告",
              desc: "2020-08",
              document: ""
            },
            {
              id: 2,
              name: "工业互联网平台标准体系框架",
              desc: "2018-02",
              document: "工业互联网平台标准体系框架（版本1.0）.pdf"
            },
            {
              id: 3,
              name: "工业互联网安全框架",
              desc: "2018-02",
              document: "工业互联网安全框架（讨论稿).pdf"
            },
            {
              id: 4,
              name: "工业互联网术语和定义",
              desc: "2019-02",
              document: ""
            },
            {
              id: 5,
              name: "工业互联网安全总体要求",
              desc: "2018-02",
              document: "工业互联网 安全总体要求.pdf"
            },
            {
              id: 6,
              name: "工业互联网平台安全防护要求",
              desc: "2018-02",
              document: "工业互联网平台 安全防护要求.pdf"
            },
            {
              id: 7,
              name: "2019年工业互联网案例汇编-典型安全解决方案",
              desc: "2020-08",
              document: ""
            },
            {
              id: 8,
              name: "工业互联网标准体系",
              desc: "2019-02",
              document: "工业互联网标准体系2.0.pdf"
            },
            {
              id: 9,
              name: "5G边缘计算安全白皮书",
              desc: "",
              document: ""
            }
          ]
        },
        {
          id: 3,
          name: "政策法规",
          icon: "law",
          width: 145,
          height: 133,
          right: 20,
          bottom: 7,
          children: [
            {
              label: 1,
              text: "◐《工业领域数据安全标准体系建设指南》",
              time: "2023-12-19"
            },
            {
              label: 2,
              text: "◐《（2023年）工业和信息化部等十六部门关于促进数据安全产业发展的指导意见》",
              time: "2023-01-03"
            },
            {
              label: 3,
              text: "◐《工业互联网安全标准体系》",
              time: "2022-02-24"
            },
            {
              label: 4,
              text: "◐《网络安全审查办法（2021）》",
              time: "2022-02-15"
            },
            {
              label: 5,
              text: "◐《国务院关于印发“十四五”数字经济发展规划的通知》",
              time: "2021-12-12"
            },
            {
              label: 6,
              text: "◐《关键信息基础设施安全保护条例》",
              time: "2021-09-01"
            },
            {
              label: 7,
              text: "◐《中华人民共和国数据安全法》",
              time: "2021-09-01"
            },
            {
              label: 8,
              text: "◐《工业互联网创新发展行动计划(2021-2023年)》",
              time: "2020-12-23"
            },
            {
              label: 9,
              text: "◐《“工业互联网+安全生产”行动计划（2021-2023年）》",
              time: "2020-10-10"
            },
            {
              label: 10,
              text: "◐《贯彻落实网络安全等级保护制度和关键信息基础设施安全保护制度的指导意见》",
              time: "2020-09-22"
            },
            {
              label: 11,
              text: "◐《工业和信息化部办公厅关于推动工业互联网加快发展的通知》",
              time: "2020-03-20"
            },
            {
              label: 12,
              text: "◐《加强工业互联网安全工作的指导意见》",
              time: "2019-07-26"
            },
            {
              label: 13,
              text: "◐《工业互联网发展行动计划(2018-2020年)》",
              time: "2018-05-31"
            }
          ]
        },
        {
          id: 4,
          name: "特征库更新",
          icon: "feature",
          width: 142,
          height: 154,
          right: 20,
          bottom: 7,
          children: []
        },
        {
          id: 5,
          name: "工业协议",
          icon: "agreement",
          width: 101,
          height: 118
        }
      ],
      abilityList:[
        {
          id:1,
          icon: "dig",
          width: 55,
          height: 55,
          name:"工业软、硬件漏洞挖掘能力",
          subList: ["固件仿真","固件分析","代码审计","介质安全","二进制"]
        },
        {
          id:2,
          icon: "detection",
          width: 45,
          height: 57,
          name:"工业威胁检测能力",
          subList: ["资产库、指纹库","主、被动资产识别","入侵检测规则","威胁情报"]
        },
        {
          id:3,
          icon: "response",
          width: 53,
          height: 53,
          name:"应急响应能力",
          subList: ["攻击溯源","取证分析","应急防护","安全服务"]
        },
        {
          id:4,
          icon: "environment",
          width: 53,
          height: 61,
          name:"工业基础环境构建能力",
          subList: ["实物/半实物仿真平台","工业流量构建","工业知识库","工控安全培训课程"]
        }
      ]
    };
  },
  computed: {
    pageSize() {
      return this.activeName === 4 ? 24 : 10;
    },
    pickedTabName() {
      return this.titleList.find(item => item.id === this.activeName).name;
    },
    pickedList() {
      return this.titleList.find(item => item.id === this.activeName).children;
    },
    totalItem() {
      return this.pickedList.length;
    },
    showList() {
      return this.pickedList.slice(this.pageSize * (this.activePage - 1), this.pageSize * this.activePage);
    },
    totalPage() {
      if (this.pickedList.length % this.pageSize === 0) {
        return this.pickedList.length / this.pageSize;
      }
      return Math.floor(this.pickedList.length / this.pageSize) + 1;
    },
    getBackgroundStyle() {
      const obj = this.titleList.find(item => item.id === this.activeName);

      return {
        "background-image": `url(${this.getImg(obj.icon)})`,
        "width": obj.width / 192 + "rem",
        "height": obj.height / 192 + "rem"
      };
    }
  },
  created() {
    this.checkLogin();
    this.getTimeList();
    if (this.$route.query.id) {
      this.activeName = Number(this.$route.query.id);
    }
  },
  mounted() {
    window.onresize = () => {
      setTimeout(() => {
        if (window.$scroller) {
          window.$scroller.update();
        }
      },1000);
    };
  },
  methods: {
    setToPaper() {
      this.activeName = 2;
      this.$nextTick(() => {
        if (window.$scroller) {
          window.$scroller.update();
        }
      });
    },
    checkLogin() {
      let cookie = document.cookie;

      let arr = cookie.split(";");

      let res = arr.map(item => item.split("=")[0].trim());

      if (res.findIndex(item => item === "login_success") !== -1) {
        this.loginState = true;
      }
    },
    login() {
      let urlString = document.domain;

      window.open("http://" + urlString + ":8080" + "/login");
    },
    changeActivePage(index) {
      if (this.activePage !== index) {
        this.activePage = index;
        this.$nextTick(() => {
          if (window.$scroller) {
            window.$scroller.update();
          }
        });
      }
    },
    changeActive(id) {
      this.activeName = id;
      this.activePage = 1;
      this.$nextTick(() => {
        if (window.$scroller) {
          window.$scroller.update();
        }
      });
    },
    getImg(str) {
      return require(`../assets/assetsNewImg/lab/${str}.png`);
    },
    getPaperImg(str) {
      return require(`../assets/assetsNewImg/lab/paper-${str}.png`);
    },
    getBgStyle(item) {
      return {
        "background-image": `url(${this.getImg(item.icon)})`,
        "width": item.width / 192 + "rem",
        "height": item.height / 192 + "rem"
      };
    },
    decreasePage() {
      if (this.activePage > 1) {
        this.activePage -= 1;
        this.$nextTick(() => {
          if (window.$scroller) {
            window.$scroller.update();
          }
        });
      }
    },
    increasePage() {
      if (this.activePage < this.totalPage) {
        this.activePage += 1;
        this.$nextTick(() => {
          if (window.$scroller) {
            window.$scroller.update();
          }
        });
      }
    },
    handleCurrentChange() {
      this.$nextTick(() => {
        if (window.$scroller) {
          window.$scroller.update();
        }
      });
    },
    fixZero(num) {
      if (num === 9) {
        return 10;
      }
      if (num === 19) {
        return 20;
      }
      if (num < 10) {
        return `0${num}`;
      }
      return num;
    },
    fixMonth(num) {
      if (num < 10) {
        return `0${num}`;
      }
      return num;
    },
    getFirstName(num){
      if (num === 1 || num === 9 || num === 19) {
        return "双湃工控漏洞库V";
      }
      return "双湃威胁情报库V";
    },
    getTimeList() {
      let res =  [];
      const arr = [1,5,9,10,15,19,20,25];
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      for (let i = 2024; i <= year;i++) {
        if (i < year) {
          for (let j = 1; j <= 12; j++) {
            arr.forEach(item => {
              res.push({
                text: `${this.getFirstName(item)}${i}${this.fixMonth(j)}${this.fixZero(item)}`,
                time:`${i}-${this.fixMonth(j)}-${this.fixZero(item)}`
              });
            });
          }
        } else {
          for (let j = 1; j <=month; j++) {
            if (j < month) {
              arr.forEach(item => {
                res.push({
                  text: `${this.getFirstName(item)}${i}${this.fixMonth(j)}${this.fixZero(item)}`,
                  time:`${i}-${this.fixMonth(j)}-${this.fixZero(item)}`
                });
              });
            } else {
              const newArr = arr.filter(items => items <= day);

              newArr.forEach(item => {
                res.push({
                  text: `${this.getFirstName(item)}${i}${this.fixMonth(j)}${this.fixZero(item)}`,
                  time:`${i}-${this.fixMonth(j)}-${this.fixZero(item)}`
                });
              });
            }
          }
        }
      }
      // console.log(res);
      this.titleList[3].children = res.reverse();
    }
  }
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: 'OPPOSans';
  src: url('../assets/assetsNewImg/lab/OPPOSans H.ttf');
}

.title-box {
  background-image: url(../assets/assetsNewImg/solution/title-bg.png);
  background-size: 100%;
  height: 424px;
  display: flex;

  .title-text {
    margin-top: 151px;
    margin-left: 163px;
    .title-name {
      font-family: OPPOSans;
      font-size: 40px;
      color: #224895; //margin-left: 174px;
    }

    .title-desc {
      font-family: OPPOSans;
      font-size: 20px;
      line-height: 32px;
      width: 711px;
      margin-top: 19px;
    }
  }
  .title-pic {
    margin-top: 52px;
    margin-left: 316px;
    width: 644px;
    height: 342px;
    background-image: url(../assets/assetsNewImg/lab/title-pic.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }

}

.sub-title-text {
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 10px 0 #99999940;
  .sub-title-text-item {
    box-sizing: border-box;
    height: 80px;
    line-height: 80px;
    font-size: 20px;
    font-family: 'OPPOSans';
    cursor: pointer;
    margin-right: 138px;

    &:last-child {
      margin-right: 0;
    }
  }

  .sub-title-text-pick {
    color: #224895;
    border-bottom: 6px solid #224895;
  }
}

.footer-symbol {
  height: 219px;
  background-color: #224895;
  display: flex;
  justify-content: center;
  align-items: center;

  .footer-symbol-img {
    width: 1257px;
    height: 123px;
    background-image: url(../assets/assetsNewImg/lab/footer-symbol.png);
    background-size: 100%;
  }
}

.content-region {
  background-color: rgb(246, 250, 255);
  .report {
    margin-left: calc(50% - 798px);
    padding-top: 67px;
    padding-bottom: 50px;
    //background-color: skyblue;
    display: flex;
    flex-wrap: wrap;

    .report-item {
      width: 760px;
      height: 376px;
      background-color: rgb(248,251,255);
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.25);
      margin-bottom: 33px;
      display: flex;

      &:nth-child(2n-1) {
        margin-right: 38px;
      }

      &:nth-child(2n) {
        margin-left: 38px;
      }

      .pic {
        margin-top: 35px;
        margin-left: 54px;
        margin-right: 54px;
        width: 229px;
        height: 303px;
        background-size: 100%;
      }

      .text {
        flex: 1;
        margin-right: 54px;
        margin-top: 35px;
        position: relative;

        .report-name {
          font-size: 24px;
          margin-bottom: 33px;
        }

        .report-desc {
          font-size: 16px;
          width: 327px;
        }

        .report-download {
          width: 148px;
          height: 47px;
          background-color: #224895;
          font-size: 16px;
          line-height: 47px;
          color: #FFF;
          text-align: center;
          position: absolute;
          left: 0;
          bottom: 50px;
          cursor: pointer;
        }
        .report-get {
          display: block;
          text-decoration: none;
        }
      }
    }
  }

  .notice {
    display: flex;
    height: 100%;

    .left-bar {
      box-sizing: border-box;
      padding-left: 56px;
      padding-top: 71px;
      width: 335px;
      height: 634px;
      margin: 53px 88px 130px 163px;
      background-image: url(../assets/assetsNewImg/lab/bar-bg.png);
      background-repeat: no-repeat;
      background-size: 100%;
      position: relative;
      .left-icon {
        position: absolute;
        right: 20px;
        bottom: 7px;
        background-size: 100%;
      }
      .left-title {
        height: 42px;
        font-size: 32px;
        line-height: 42px;
        color:#FFF;
        font-family: 'OPPOSans';
        padding-bottom: 7px;
        border-bottom: 6px solid #FFF;
        display: inline-block;
      }
    }

    .bar-text {
      font-size: 20px;
      font-family: 'OPPOSans';
      color: #FFF;
    }
    .right-part {
      margin-top: 53px;
      width: 1174px;

      .page-container {
        margin-top: 47px;
        display: flex;
        margin-bottom: 130px;
        .page-square {
          width: 49px;
          height: 49px;
          font-size: 16px;
          text-align: center;
          line-height: 49px;
          margin-right: 18px;
          border: 1px solid #224895;
          box-sizing: border-box;
          cursor: pointer;
        }
        .picked-page-square {
          color: #FFF;
          background-color: #224895;
        }
      }

      .right-part-title {
        height: 94px;
        width: 100%;
        background-image: url(../assets/assetsNewImg/lab/right-part.png);
        background-size: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 38px;
        .title-icon {
          width: 32px;
          height: 34px;
          background-image: url(../assets/assetsNewImg/lab/right-icon.png);
          background-size: 100%;
          margin-left: 44px;
        }
        .title-text {
          font-size: 20px;
          color: #FFF;
          font-family: 'OPPOSans';
          margin-left: 15px;
        }
      }

      .right-line {
        box-sizing: border-box;
        border-bottom: 1px solid #EFEFEF;
        height: 60px;
        position: relative;
        font-size: 18px;

        .right-line-text {
          line-height: 60px;
        }

        .right-line-time {
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          display: flex;
          align-items: center;
          color: #838383;
        }

        .clock {
          width: 14px;
          height: 14px;
          background-image: url(../assets/assetsNewImg/lab/clock.png);
          background-size: 100%;
          margin-right: 7px;
        }
      }
      .agreement-desc {
        width: 1038px;
        font-size: 18px;
        margin-bottom: 50px;
      }
      .agreement-pic {
        background-size: 100%;
        margin-bottom: 170px;
        width:1085px;
        height: 1388px;
        background-image: url(../assets/assetsNewImg/lab/agreement-pic.png);
      }
      .right-box {
        font-size: 16px;
        line-height: 30px;

        .right-box-title-box {
          display: flex;
          align-items: center;
          margin-bottom: 33px;

          .title-bold-symbol {
            width: 21px;
            height: 21px;
            background-color: #224895;
            margin-right: 13px;
          }
        }

        .right-box-title-box-inner {
          display: flex;
          align-items: center;
          margin-bottom: 9px;

          .title-bold-symbol-inner {
            width: 16px;
            height: 16px;
            background-color: #5576C6;
            margin-right: 13px;
            margin-left: 5px;
            border-radius: 50%;
          }

          .title-bold-inner {
            font-family: 'OPPOSans';
          }
        }

        .result-content {
          margin-bottom: 40px;
        }

        .title-bold {
          font-size: 24px;
          font-family: 'OPPOSans';
        }

        .intro-content {
          margin-bottom: 59px;
        }
      }
      .feature-container {
        display: flex;
        flex-wrap: wrap;
        .feature-item {
          width: 183px;
          height: 256px;
          background-color: #D2D6F1;
          margin-right: 15px;
          margin-bottom: 30px;
          box-sizing: border-box;
          padding-left: 16px;
          padding-top: 36px;
          position: relative;
          &:nth-child(6n) {
            margin-right: 0;
          }
          .feature-kind {
            font-size: 16px;
            line-height: 21px;
            color: #224895;
            font-family: 'OPPOSans';
          }
          .feature-version {
            width:167px;
            height: 46px;
            background-color: #9BA0CB;
            line-height: 46px;
            color:#FFF;
            font-size: 24px;
            box-sizing: border-box;
            padding-left: 21px;
            margin-top: 7px;
            overflow: hidden;
          }
          .feature-time {
            margin-top: 90px;
            font-size: 14px;
            line-height: 18px;
            color:#224895;
            font-family: 'OPPOSans';
          }
          .feature-bg {
            position: absolute;
            left:44px;
            top: 28px;
            width: 168px;
            height: 215px;
            background-size: 100%;
            background-image: url(../assets/assetsNewImg/lab/feature-bg.png);
          }
        }
      }
    }
  }
  .lab-room-one {
    //display: flex;
    padding-left:163px;
    padding-top: 118px;
    .lab-room-one-list {
      display: flex;
      .lab-room-one-pic {
        width: 794px;
        height: 448px;
        background-size: 100%;
        background-image: url(../assets/assetsNewImg/lab/lab-room-one.png);
        position: relative;
        .lab-icon {
          width: 150px;
          height: 126px;
          background-size: contain;
          background-position-x: center;
          background-position-y: center;
          background-repeat: no-repeat;
          background-image: url(../assets/assetsNewImg/lab/lab-icon.png);
          position: absolute;
          left:40px;
          top: 22px;
          color: #FFF;
          font-size: 48px;
          line-height: 126px;
          text-align: center;
        }
      }
      .lab-room-one-capable {
        height: 448px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 61px;
        .lab-capable-item {
          width:742px;
          height: 102px;
          box-sizing: border-box;
          background-color: rgb(246,250,255);
          border: 1px solid  rgb(213,220,231);
          border-radius: 12px;
          display: flex;
          .lab-capable-iconbox {
            width: 90px;
            height: 100px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            .lab-capable-icon {
              background-size: 100%;
            }
          }
          .lab-capable-title {
            color: rgba(34, 72, 149, 1);
            font-size: 20px;
            line-height: 26px;
            margin-top: 14px;
            font-family: OPPOSans;
          }
          .lab-capable-textbox {
            margin-top: 14px;
            display: flex;
            .lab-capable-textbox-item {
              display: flex;
              align-items: center;
              margin-right: 28px;
              &:last-child {
                margin-right: 0;
              }
              .lab-capable-symbol {
                width: 4px;
                height: 4px;
                background-color: rgba(34, 72, 149, 1);
                transform: rotate(45deg);
                margin-right: 4px;
              }
              .lab-capable-text {
                color: rgba(72, 72, 72, 1);
                font-size: 18px;
                line-height: 24px;
                font-family: OPPOSans;
              }
            }
          }
        }
      }
    }
    .lab-room-one-content {
      position: relative;
      margin-bottom: 23px;
      .lab-room-one-ability {
        position: absolute;
        bottom: 0;
        left: 855px;
        font-size: 24px;
        line-height: 32px;
      }
    }
  }
  .lab-room-title {
    font-size: 32px;
    height: 42px;
    line-height: 42px;
  }
  .lab-room-desc {
    margin-top: 15px;
    font-size: 16px;
    line-height: 30px;
    width: 787px;
    text-align: justify;
  }
  .desc-gap {
    margin-bottom: 60px;
  }
  .lab-room-two {
    margin-top: 126px;
    padding-bottom: 75px;
    display: flex;
    position: relative;
    .lab-room-two-bg {
      position: absolute;
      left: 0;
      top: -128px;
      width: 693px;
      height: 357px;
      background-size: 100%;
      background-image: url(../assets/assetsNewImg/lab/lab-room-bg.png);
    }
    .lab-room-two-content {
      margin-left: 163px;
      .lab-room-two-partner {
        margin-top: 30px;
        width: 732px;
        height:111px;
        background-size: 100%;
        background-image: url(../assets/assetsNewImg/lab/lab-room-partner.png);
      }
    }
    .lab-room-two-pic {
      margin-left: 101px;
      width: 737px;
      height: 374px;
      background-size: 100%;
      background-image: url(../assets/assetsNewImg/lab/lab-room-two.png);
    }
  }
}
.el-pagination {
  padding: 0;
  margin-top: 47px;
  margin-bottom: 130px;
  /deep/ .btn-prev {
    background-color: transparent;
    width: 49px;
    height: 49px;
    text-align: center;
    line-height: 49px;
    margin-right: 18px;
    padding: 0;
    border: 1px solid #224895;
  }
  /deep/ .btn-next {
    background-color: transparent;
    width: 49px;
    height: 49px;
    text-align: center;
    line-height: 49px;
    margin-right: 18px;
    padding: 0;
    border: 1px solid #224895;
  }
  /deep/ .el-icon {
    font-size: 16px;
  }
  /deep/ .el-pager li {
    background-color: transparent;
    min-width: 49px;
    height: 49px;
    font-size: 16px;
    text-align: center;
    line-height: 49px;
    margin-right: 18px;
    padding: 0 8px;
    border: 1px solid #224895;
    &.active {
      color: #FFF;
      background-color: #224895;
      &:hover {
        color: #FFF;
      }
    }
    &:hover {
      color: #224895;
    }
  }
}
</style>
